import './Badge.scss';

const Badge = ({ variant, text }) => (
  <span className={`font-weight-700 text-xs p-1  badge ${variant}`}>{text}</span>
);

export default Badge;
